import React from 'react';
import { Truck, Shield, RotateCcw, Headphones, CreditCard, Award } from 'lucide-react';


const FeaturesSection = () => {
  const features = [
    {
      icon: <Truck size={32} />,
      title: 'Envío gratis',
      description: 'Envío rápido y gratuito en compras seleccionadas.',
      color: '#00a650',
    },
    {
      icon: <Shield size={32} />,
      title: 'Pago seguro',
      description: 'Tus pagos están protegidos y son 100% seguros.',
      color: '#3483fa',
    },
    {
      icon: <RotateCcw size={32} />,
      title: 'Devoluciones fáciles',
      description: 'Devolvé tus productos sin complicaciones.',
      color: '#ff6b35',
    },
    {
      icon: <Headphones size={32} />,
      title: 'Soporte dedicado',
      description: 'Atención al cliente personalizada y rápida.',
      color: '#8b5cf6',
    },
    {
      icon: <CreditCard size={32} />,
      title: 'Pagos flexibles',
      description: 'Elegí la forma de pago que más te convenga.',
      color: '#f59e0b',
    },
    {
      icon: <Award size={32} />,
      title: 'Calidad garantizada',
      description: 'Productos originales y con garantía.',
      color: '#ef4444',
    },
  ];

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '60px auto',
      padding: '0 20px',
    }}>
      <div style={{
        textAlign: 'center',
        marginBottom: '50px',
      }}>
        <h2 style={{
          fontSize: 'clamp(2rem, 4vw, 2.5rem)',
          fontWeight: '700',
          color: '#333',
          marginBottom: '16px',
        }}>
          ¿Por qué elegirnos?
        </h2>
        <p style={{
          fontSize: '18px',
          color: '#666',
          maxWidth: '600px',
          margin: '0 auto',
          lineHeight: '1.6',
        }}>
          La mejor experiencia de compra en Paraguay.
        </p>
      </div>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '16px',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
      }}>
        <h3 style={{
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          fontWeight: '700',
          marginBottom: '16px',
          margin: 0,
        }}>
          ¿Listo para empezar a comprar?
        </h3>
        <p style={{
          fontSize: '16px',
          marginBottom: '24px',
          opacity: 0.9,
          margin: '16px 0 24px 0',
        }}>
          ¡Unite a miles de clientes satisfechos!
        </p>
        <button
          style={{
            backgroundColor: 'white',
            color: '#667eea',
            padding: '16px 32px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
          }}
          onClick={() => window.location.href = '/products'}
        >
          Explorar productos
        </button>
      </div>
    </div>
  );
};

export default FeaturesSection;

